import { Button } from "@components/atoms/Button"
import { VSpace } from "@components/layout/Spacer"
import { EditableText, defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Title with button",
  category: "common",
  icon: "heading",
  keywords: ["title", "button", "heading"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("general/title-with-button", (props) => {
  return (
    <div className="grid-auto gap-6">
      <div className="col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3">
        <div className="flex flex-col items-center gap-5 py-6 w-full">
          <EditableText
            as="span"
            store="subtitle"
            className="type-label-caps text-mid-grey"
            placeholder="Enter subtitle..."
          />
          <EditableText as="h4" store="title" className="!text-center" placeholder="Enter title..." />
        </div>
      </div>

      {props.button && (
        <div className="col-span-12 flex flex-col justify-center items-center">
          <Button
            color="yellow"
            size="medium"
            href={props.button?.url ?? undefined}
            target={props.button?.target ? "_blank" : undefined}
          >
            {props.button.title}
          </Button>
          <VSpace initial={6} />
        </div>
      )}
    </div>
  )
})
